var eUserInfo = {
  company_ic: "duis",
  company_id: "8bd2a4865fee40a099c313eeae4689",
  company_name: "极酷IOT",
  is_admin: "0",
  logo_url: "",
  program_type: "geeku",
  show_page: "2",
  user_name: "admin",
}

// 部门数据表
let departmentData = {
  list: [
    {
      id: 0,
      name: "全部",
      // level: 1,
    },
    {
      id: 1,
      parent_id: 0,
      parent_name: '全部',
      name: "研发部",
      // level: 2,
    },
    {
      id: 2,
      parent_id: 1,
      parent_name: '研发部',
      name: "硬件组",
      // level: 3,
    },
    {
      id: 3,
      parent_id: 1,
      parent_name: '研发部',
      name: "软件组",
      // level: 3,
    },
    {
      id: 4,
      parent_id: 0,
      parent_name: '全部',
      name: "业务部",
      // level: 2,
    },
    {
      id: 5,
      parent_id: 4,
      parent_name: '业务部',
      name: "业务1部",
      // level: 3,
    },
    {
      id: 6,
      parent_id: 0,
      parent_name: '全部',
      name: "业务2部",
      // level: 2,
    },
  ],
  // 树状结构list
  treeList: []
}

// 用户数据表
let userData = {
  list: [
    {
      user_id: 1,
      user_name: "张三",
      user_account: "zhangsan",
      phone_no: "13550000000",
      email: "13@qq.com",
      create_time: "2019-09-19 18:25:59",
      user_state: "1",
      department_id: 0,
      role_id: ["10"],
      userProfile: {
        faceimage: [],
        fingerprint: [],
        staffcard: ["2417426128"]
      }
    },
    {
      user_id: 2,
      user_name: "李四",
      user_account: "lisi",
      phone_no: "13550000000",
      email: "13@qq.com",
      create_time: "2019-09-19 18:25:59",
      user_state: "1",
      department_id: 0,
      role_id: ["10"],
      userProfile: {
        faceimage: [],
        fingerprint: [],
        staffcard: ["2417426128"]
      }
    },
    {
      user_id: 3,
      user_name: "王五",
      user_account: "wangwu",
      phone_no: "13550000000",
      email: "13@qq.com",
      create_time: "2019-09-19 18:25:59",
      user_state: "1",
      department_id: 0,
      role_id: ["10"],
      userProfile: {
        faceimage: [],
        fingerprint: [],
        staffcard: ["2417426128"]
      }
    }
  ]
}

// 角色数据表
let roleData = {
  list: [
    {
      role_id: 1,
      role_name: "管理员",
      role_desc: "",
      user_list: [
        { user_name: '张三' }
      ]
    },
    {
      role_id: 2,
      role_name: "员工",
      role_desc: "",
      user_list: [
        { user_name: '张三' }
      ]
    }
  ]
}

// 角色权限分配数据
let roleAuthData = {
  companyAccessList: [
    {
      function_id: "1",
      function_name: "用户中心",
      function_tab: "CUserManege",
      children: [
        {
          function_id: "2",
          function_name: "组织管理",
          function_tab: "COrganizeManage",
          parent_function_id: "1",
        }
      ]
    },
    {
      function_id: "3",
      function_name: "控制中心",
      function_tab: "CSceneManage",
      children: [
        {
          function_id: "4",
          function_name: "空间管理",
          function_tab: "CSceneList",
          parent_function_id: "3",
        },
        {
          function_id: "5",
          function_name: "设备中心",
          function_tab: "CDeviceCenter",
          parent_function_id: "3",
        },
        {
          function_id: "6",
          function_name: "授权管理",
          function_tab: "CAuthorizationCenter",
          parent_function_id: "3",
        },
      ]
    },
  ],
  roleAccess: [1, 2, 4]
}

// 场景位置数据
let sceneData = {
  list: [
    {
      space_id: 0,
      space_name: "中国 广东省 广州市 黄埔区",
      level: -1,
    },
    {
      space_id: 1,
      parent_id: 0,
      space_name: "神舟路19号",
      level: 0,
    },
    {
      space_id: 2,
      parent_id: 1,
      space_name: "极酷物联公司",
      level: 1,
    },
    {
      space_id: 3,
      parent_id: 2,
      space_name: "一楼",
      level: 2,
    },
    {
      space_id: 4,
      parent_id: 2,
      space_name: "二楼",
      level: 2,
    },
    {
      space_id: 5,
      parent_id: 4,
      space_name: "总裁办公室",
      level: 3,
    },
    {
      space_id: 6,
      parent_id: 4,
      space_name: "市场部",
      level: 3,
    },
    {
      space_id: 7,
      parent_id: 4,
      space_name: "仓库",
      level: 3,
    },
    {
      space_id: 8,
      parent_id: 2,
      space_name: "三楼",
      level: 2,
    },
  ],
  // 树状结构list
  treeList: []
}

// 场景列表设备列表
let sceneDeviceData = {
  list: [
    {
      device_no_id: "T0000000180",
      device_name: "医疗耗材柜",
      device_type: "医疗仓",
      space_name: "极酷物联公司/二楼/仓库"
    },
    {
      device_no_id: "T0000000181",
      device_name: "极酷无人仓",
      device_type: "RFID无人仓",
      space_name: "极酷物联公司/二楼/仓库"
    },
    {
      device_no_id: "T0000000182",
      device_name: "极酷机器人",
      device_type: "盘点机器人",
      space_name: "极酷物联公司/二楼/仓库"
    },
    {
      device_no_id: "T0000000183",
      device_name: "工具领用柜",
      device_type: "E站",
      space_name: "极酷物联公司/二楼/仓库"
    },
    {
      device_no_id: "T0000000184",
      device_name: "资产管理柜",
      device_type: "RFID工具柜",
      space_name: "极酷物联公司/二楼/仓库"
    },
    {
      device_no_id: "T0000000185",
      device_name: "钥匙柜",
      device_type: "智能钥匙柜",
      space_name: "极酷物联公司/二楼/仓库"
    },
  ]
}

// 授权管理-已授权用户列表
let beAuthUserData = {
  list: [
    {
      box_number: "3",
      user_type: "内部员工",
      department_name: "全部/研发部/软件部",
      user_name: "张三",
      account: "zhangsan",
      phone_no: "13550000000",
      device_no_id: "T0000000001",
      end_usetime: "0000-00-00 00:00:00",
      id: "567",
      use_count: "100",
      use_timetype: "0",
    },
    {
      box_number: "3",
      user_type: "内部员工",
      department_name: "全部/研发部/软件部",
      user_name: "李四",
      account: "lisi",
      phone_no: "13550000000",
      device_no_id: "T0000000001",
      start_usetime: "2019-01-01",
      end_usetime: "2020-01-01",
      id: "567",
      use_count: 999999,
      use_timetype: 1,
    },
    {
      box_number: "3",
      user_type: "内部员工",
      department_name: "全部/研发部/软件部",
      user_name: "王五",
      account: "wangwu",
      phone_no: "13550000000",
      device_no_id: "T0000000001",
      end_usetime: "0000-00-00 00:00:00",
      id: "567",
      use_count: -1,
      use_timetype: "0",
    },
  ]
}

let equipmentData = {
  typeList: {
    ZHGYL: [
      // 医疗柜
      {
        name: "医疗仓",
        code: "MEDITOOL",
        type: "1",
        id: 1
      },
      // RFID无人仓
      {
        name: "RFID无人仓",
        code: "WAREHOUSE",
        type: "4",
        id: 2
      },
      // 盘点机器人
      {
        name: "盘点机器人",
        code: "INVENTORYROBOT",
        type: "3",
        id: 3
      },
      // e站
      {
        name: "E站",
        code: "ESTAND",
        type: "1",
        id: 4
      },
      // RFID工具柜
      {
        name: "RFID工具柜",
        code: "TOOL",
        type: "1",
        id: 5
      },
      // 智能钥匙柜
      {
        name: "智能钥匙柜",
        code: "KEYBOX",
        type: "1",
        id: 6
      }
    ],
    ZHKJ: [
      // {
      // 	name: "门禁",
      // 	code: "ACCESS",
      // 	type: "2"
      // },
      // {
      // 	name: "周转柜",
      // 	code: "TURN",
      // 	type: "1"
      // },
      // {
      // 	name: "魔方柜",
      // 	code: "MAGICCUBE",
      // 	type: "1"
      // }
    ]
  },
  deviceList: [
    // 医疗柜
    {
      code: "MEDITOOL",
      device_name: "医疗耗材柜",
      device_no_id: "C0000000011",
      online: false,
      type: "1",
    },
    {
      code: "MEDITOOL",
      device_name: "医疗耗材柜2",
      device_no_id: "C0000000012",
      online: true,
      type: "1",
    },
    // RFID无人仓
    {
      code: "WAREHOUSE",
      device_name: "极酷无人仓",
      device_no_id: "C0000000021",
      online: false,
      type: "4",
    },
    {
      code: "WAREHOUSE",
      device_name: "极酷无人仓2",
      device_no_id: "C0000000022",
      online: true,
      type: "4",
    },
    // 盘点机器人
    {
      code: "INVENTORYROBOT",
      device_name: "极酷机器人",
      device_no_id: "C0000000031",
      online: false,
      type: "3",
    },
    {
      code: "INVENTORYROBOT",
      device_name: "极酷机器人2",
      device_no_id: "C0000000032",
      online: true,
      type: "3",
    },
    // e站
    {
      code: "ESTAND",
      device_name: "工具领用柜",
      device_no_id: "C0000000041",
      online: false,
      type: "1",
    },
    {
      code: "ESTAND",
      device_name: "工具领用柜2",
      device_no_id: "C0000000042",
      online: true,
      type: "1",
    },
    // RFID工具柜
    {
      code: "TOOL",
      device_name: "资产管理柜",
      device_no_id: "C0000000051",
      online: false,
      type: "1",
    },
    {
      code: "TOOL",
      device_name: "资产管理柜2",
      device_no_id: "C0000000052",
      online: true,
      type: "1",
    },
    // 智能钥匙柜
    {
      code: "KEYBOX",
      device_name: "钥匙柜",
      device_no_id: "C0000000061",
      online: false,
      type: "1"
    },
    {
      code: "KEYBOX",
      device_name: "钥匙柜2",
      device_no_id: "C0000000062",
      online: true,
      type: "1"
    }
  ],
  deviceBoxList: [
    {
      box_number: "1",
      box_size: "A",
      openStatus: "on",
      status: "0",
    },
    {
      box_number: "2",
      box_size: "A",
      openStatus: "off",
      status: "1",
    },
    {
      box_number: "3",
      box_size: "B",
      openStatus: "off",
      status: "1",
    },
    {
      box_number: "4",
      box_size: "B",
      openStatus: "on",
      status: "0",
    },
    {
      box_number: "5",
      box_size: "B",
      openStatus: "off",
      status: "0",
    },
    {
      box_number: "6",
      box_size: "C",
      openStatus: "on",
      status: "0",
    },
    {
      box_number: "7",
      box_size: "C",
      openStatus: "off",
      status: "1",
    },
    {
      box_number: "8",
      box_size: "C",
      openStatus: "off",
      status: "1",
    },
    {
      box_number: "9",
      box_size: "D",
      openStatus: "off",
      status: "0",
    },
    {
      box_number: "10",
      box_size: "D",
      openStatus: "off",
      status: "0",
    },
    {
      box_number: "11",
      box_size: "E",
      openStatus: "on",
      status: "0",
    },
    {
      box_number: "12",
      box_size: "E",
      openStatus: "off",
      status: "0",
    },
  ]
}

export {
  eUserInfo,
  departmentData,
  userData,
  roleData,
  roleAuthData,
  sceneData,
  sceneDeviceData,
  beAuthUserData,
  equipmentData
}


//////////////////
// WEBPACK FOOTER
// ./static/js/exp/config.js
// module id = fFw/
// module chunks = 1